<template>
  <Navbar />
  <component :is="componentName" />
</template>

<script setup>
import Navbar from "~/components/Navbar.vue";
import RotatingCube from "~/components/home/skeleton/HeroIntroSectionSkeleton.vue";

definePageMeta({
  layout: "custom",
});

const componentName = shallowRef(RotatingCube);

if (process.client) {
  componentName.value = defineAsyncComponent(() =>
    import("~/components/home/index.vue")
  );
}
</script>

<style lang="scss" scoped></style>
